import { createAction, props } from '@ngrx/store';
import {
	IAssigneeOrganization,
	ISelectableOptions,
} from '@app/shared/interfaces/selectable-options.interfaces';
import { IBuilding } from '@shared/interfaces/building.interfaces';
import { ISidebarConfig } from '@layout/au-right-sidebar/right-sidebar.interfaces';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { IRightSidebarNavigation, IWorkspaceComponentContext } from './layout.reducer';
import {
	IAuBreadcrumbMenuConfig,
	IAuBreadcrumbsConfig,
} from '@core/au-breadcrumb/interfices/au-breadcrumbs.interface';

export const NavSidebarExpanded = createAction('[Layout] Navigation sidebar expanded');
export const NavSidebarCollapsed = createAction('[Layout] Navigation sidebar minimized');
export const LoadSelectableOptions = createAction(
	'[Layout] Load selectable options for application'
);
export const SelectableOptionsLoaded = createAction(
	'[Layout] Selectable options for application loaded',
	props<{ selectableOptions: ISelectableOptions }>()
);
export const LoadAssignees = createAction(
	'[Layout] Load Selectable Assignees for application'
);
export const AssigneeListLoaded = createAction(
	'[Layout] Selectable assignee options loaded',
	props<{ assignees: IAssigneeOrganization[] }>()
);
export const AddBuildingToSelectableOption = createAction(
	'[Layout] Update selectable options with new building',
	props<{ building: IBuilding }>()
);
export const UpdateBuildingsInSelectableOption = createAction(
	'[Layout] Update one building inside selectable options',
	props<{ building: IBuilding }>()
);
export const SelectableOptionsFailedToLoad = createAction(
	'[Layout] Selectable options for application failed to load',
	props<{ error: any }>()
);
export const SelectableAssigneesFailedToLoad = createAction(
	'[Layout] Selectable assignee options failed to load',
	props<{ error: any }>()
);

// Right sidebar action
export const ClearRightSidebarHisory = createAction('[Layout] Clear sidebar history');

export const ClearRightSidebarInitialComponent = createAction(
	'[Layout] Clear initial page for right sidebar'
);

export const SetRightSidebarInitialComponent = createAction(
	'[Layout] Set initial page for right sidebar',
	props<{
		config: Partial<IRightSidebarNavigation>;
	}>()
);

export const AddItemToNavigationHistory = createAction(
	'[Layout] Add item to sidebar navigation history',
	props<{
		config: Partial<ISidebarConfig>;
		component: CmmsPages;
	}>()
);

export const SetNavigationHistory = createAction(
	'[Layout] Set sidebar navigation history',
	props<{
		history: { config: Partial<ISidebarConfig>; component: CmmsPages }[];
	}>()
);

export const GotoPreviousPageOnRightSidebar = createAction(
	'[Layout] Goto previous Page On Right Sidebar'
);

export const NavigateToSidebarPage = createAction(
	'[Layout] Navigate to right sidebar page',
	props<{ page: CmmsPages; config?: Partial<ISidebarConfig> }>()
);

export const SetRightSidebarComponentContext = createAction(
	'[Layout] Set component context',
	props<{ componentContext: Partial<IWorkspaceComponentContext> }>()
);

export const SetAttachFormValue = createAction(
	'[Layout] Set form value attach data',
	props<{ formValue }>()
);

export const SetLinkedObjects = createAction(
	'[Layout] Set linked objects for bulk linking',
	props<{ selectedObjects }>()
);

// auBreadcrumb actions
export const setAuBreadcrumb = createAction(
	'[Layout] Set breadcrumb configuration',
	props<{ configuration: IAuBreadcrumbsConfig[] }>()
);

export const setAuBreadcrumbMenu = createAction(
	'[Layout] Set breadcrumb menu configuration',
	props<{ breadcrumbMenuConfig: IAuBreadcrumbMenuConfig }>()
);

export const clearAuBreadcrumb = createAction('[Layout] Clear breadcrumb configuration');
// end auBreadcrumb actions

// end right sidebar action
